import React, { useState } from 'react';

const TestDragDrop = () => {
  const [isDragging, setIsDragging] = useState(false);
  const [files, setFiles] = useState([]);
  const [logs, setLogs] = useState([]);

  const addLog = (message) => {
    console.log(message);
    setLogs(prev => [...prev, `${new Date().toLocaleTimeString()}: ${message}`]);
  };

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDragIn = (e) => {
    e.preventDefault();
    e.stopPropagation();
    addLog('Drag in');
    if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
      setIsDragging(true);
    }
  };

  const handleDragOut = (e) => {
    e.preventDefault();
    e.stopPropagation();
    addLog('Drag out');
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
    
    addLog('Drop event fired!');
    
    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
      const droppedFiles = Array.from(e.dataTransfer.files);
      addLog(`Dropped ${droppedFiles.length} files`);
      
      droppedFiles.forEach((file, index) => {
        addLog(`File ${index}: ${file.name}, type: ${file.type}, size: ${file.size}`);
        addLog(`File path: ${file.path || 'NO PATH'}`);
        
        // Log all properties
        const props = Object.getOwnPropertyNames(file);
        addLog(`File properties: ${props.join(', ')}`);
      });
      
      setFiles(droppedFiles);
      e.dataTransfer.clearData();
    }
  };

  return (
    <div style={{ padding: '20px' }}>
      <h2>Drag Drop Test Component</h2>
      
      <div
        onDrop={handleDrop}
        onDragOver={handleDrag}
        onDragEnter={handleDragIn}
        onDragLeave={handleDragOut}
        style={{
          border: isDragging ? '2px solid #000' : '2px dashed #ccc',
          borderRadius: '20px',
          padding: '20px',
          minHeight: '200px',
          backgroundColor: isDragging ? '#f0f0f0' : 'white',
          marginBottom: '20px'
        }}
      >
        <p>Drop files here</p>
        <p>Is dragging: {isDragging ? 'YES' : 'NO'}</p>
      </div>

      <div>
        <h3>Dropped Files:</h3>
        {files.map((file, index) => (
          <div key={index}>
            <strong>{file.name}</strong> - {file.type} - {file.size} bytes
            <br />Path: {file.path || 'NO PATH PROPERTY'}
          </div>
        ))}
      </div>

      <div style={{ marginTop: '20px', fontSize: '12px', fontFamily: 'monospace' }}>
        <h3>Logs:</h3>
        {logs.map((log, index) => (
          <div key={index}>{log}</div>
        ))}
      </div>
    </div>
  );
};

export default TestDragDrop;